//#region src/isArray.ts
/**
* @category Type Guards
*/
function isArray(val) {
	return Array.isArray(val);
}
var isArray_default = isArray;

//#endregion
export { isArray_default };
//# sourceMappingURL=isArray-CeTKVOa4.mjs.map